import { Card } from 'primereact/card';
import { Chip } from 'primereact/chip';
import { Skeleton } from 'primereact/skeleton';
import styles from './StatsSection.module.css';

interface Stat {
  label: string;
  value?: string;
  subtitle?: string;
  icon: string;
  color: string;
  trend?: string;
}

interface StatsSectionProps {
  dynamicStats: Stat[] | null;
  isLoading: boolean;
}

const staticStats: Stat[] = [
  {
    label: 'Total Documents',
    icon: 'pi pi-file',
    color: '#377dff'
  },
  {
    label: 'Total Analyses',
    icon: 'pi pi-chart-line',
    color: '#14692a'
  },
  {
    label: 'Active Gaps',
    icon: 'pi pi-exclamation-triangle',
    color: '#ff6b6b'
  },
  {
    label: 'Avg Confidence',
    icon: 'pi pi-check-circle',
    color: '#f59e0b'
  }
];

export const StatsSection = ({
  dynamicStats,
  isLoading
}: StatsSectionProps) => (
  <section className={styles.statsSection}>
    <div className={styles.statsGrid}>
      {isLoading
        ? staticStats.map((stat) => (
            <Card key={stat.label} className={styles.statsCard}>
              <div className={styles.statHeader}>
                <div className={styles.statInfo}>
                  <div className={styles.statLabel}>{stat.label}</div>
                  <Skeleton width="80px" height="2rem" />
                </div>
                <div
                  className={styles.statIcon}
                  style={{ backgroundColor: stat.color }}
                >
                  <i className={stat.icon}></i>
                </div>
              </div>
              <div className={styles.statFooter}>
                <Skeleton width="60%" height="1rem" />
                <Skeleton width="80px" height="24px" />
              </div>
            </Card>
          ))
        : dynamicStats
          ? dynamicStats.map((stat) => (
              <Card key={stat.label} className={styles.statsCard}>
                <div className={styles.statHeader}>
                  <div className={styles.statInfo}>
                    <div className={styles.statLabel}>{stat.label}</div>
                    <div className={styles.statValue}>{stat.value}</div>
                  </div>
                  <div
                    className={styles.statIcon}
                    style={{ backgroundColor: stat.color }}
                  >
                    <i className={stat.icon}></i>
                  </div>
                </div>
                <div className={styles.statFooter}>
                  <span className={styles.statSubtitle}>{stat.subtitle}</span>
                  <Chip
                    label={stat.trend}
                    icon="pi pi-arrow-up"
                    className={styles.trendChip}
                  />
                </div>
              </Card>
            ))
          : staticStats.map((stat) => (
              <Card key={stat.label} className={styles.statsCard}>
                <div className={styles.statHeader}>
                  <div className={styles.statInfo}>
                    <div className={styles.statLabel}>{stat.label}</div>
                    <div className={styles.statValue}>0</div>
                  </div>
                  <div
                    className={styles.statIcon}
                    style={{ backgroundColor: stat.color }}
                  >
                    <i className={stat.icon}></i>
                  </div>
                </div>
                <div className={styles.statFooter}>
                  <span className={styles.statSubtitle}>No data</span>
                  <Chip
                    label="0"
                    icon="pi pi-arrow-up"
                    className={styles.trendChip}
                  />
                </div>
              </Card>
            ))}
    </div>
  </section>
);
